import { Plus, Trash } from "@phosphor-icons/react";
import { Section } from "./Section";

export default function ProjectsSection({ resume, setResume, open, onToggle }) {
  const add = () =>
    setResume((r) => ({
      ...r,
      projects: [...r.projects, { id: crypto.randomUUID(), name: "", link: "", description: "", tech: "" }],
    }));
  const update = (i, k, v) =>
    setResume((r) => {
      const next = [...r.projects];
      next[i] = { ...next[i], [k]: v };
      return { ...r, projects: next };
    });
  const remove = (i) =>
    setResume((r) => ({ ...r, projects: r.projects.filter((_, idx) => idx !== i) }));

  return (
    <Section id="projects" title="Projects" open={open} onToggle={onToggle}>
      <div className="space-y-4">
        {resume.projects.map((p, i) => (
          <div key={p.id} className="border border-black/10 p-4 space-y-3" data-testid={`project-item-${i}`}>
            <div className="flex items-center justify-between">
              <div className="label-mono">Project {i + 1}</div>
              {resume.projects.length > 1 && (
                <button onClick={() => remove(i)} className="text-neutral-400 hover:text-[#FF2A00]" data-testid={`remove-project-${i}`}>
                  <Trash size={14} weight="bold" />
                </button>
              )}
            </div>
            <div className="grid grid-cols-2 gap-3">
              <input className="field-input" placeholder="Name" value={p.name} onChange={(e) => update(i, "name", e.target.value)} data-testid={`proj-name-${i}`} />
              <input className="field-input" placeholder="Link (optional)" value={p.link} onChange={(e) => update(i, "link", e.target.value)} data-testid={`proj-link-${i}`} />
              <input className="field-input col-span-2" placeholder="Tech stack" value={p.tech} onChange={(e) => update(i, "tech", e.target.value)} data-testid={`proj-tech-${i}`} />
              <textarea className="field-textarea col-span-2 min-h-[52px]" placeholder="What it is, what you built, and the impact." value={p.description} onChange={(e) => update(i, "description", e.target.value)} data-testid={`proj-desc-${i}`} />
            </div>
          </div>
        ))}
        <button onClick={add} className="btn-secondary text-xs px-4 py-2" data-testid="add-project-button">
          <Plus size={14} weight="bold" /> Add project
        </button>
      </div>
    </Section>
  );
}
